import { Stack, styled } from '@planne-software/uni/mui/material';

export const ListArea = styled(Stack)(({ theme }) => ({
  maxWidth: '100%',
  flexDirection: 'column',
  gap: theme.tokens.spacing['spacing-1xmini'],
  padding: theme.tokens.spacing['spacing-sm'],
}));
